/* eslint-disable react-hooks/exhaustive-deps */
import { FORM_STATUS_ENUM } from "@interfaces/response";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export type buttonStatus = "validado" | "completo" | "editar" | "llenar";

export interface buttonProps {
  disabled: boolean;
  buttonLabel: string;
  backgroundColor: string;
  color?: string;
}

export interface ButtonFormEnumProps {
  formStatus: FORM_STATUS_ENUM | null;
  fakeDisabled?: boolean;
  onClick: () => void;
}

const ButtonFormEnum: React.FC<ButtonFormEnumProps> = ({ formStatus, fakeDisabled, onClick }) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [btnParams, setBtnParams] = useState<buttonProps>({
    disabled: false,
    buttonLabel: "Llenar",
    backgroundColor: theme?.palette?.primary?.main,
    color: "#FFFFFF",
  });

  const generateButtonParams = () => {
    let btnParams: buttonProps = {
      disabled: false,
      buttonLabel: "Llenar",
      backgroundColor: theme?.palette?.primary?.main,
      color: "#FFFFFF",
    };

    if (formStatus === "VALIDADO") {
      btnParams = {
        disabled: true,
        buttonLabel: "Validado",
        backgroundColor: theme?.palette?.primary?.light,
        color: theme?.palette?.primary?.main,
      };
    } else if (formStatus === "COMPLETO") {
      btnParams = {
        disabled: true,
        buttonLabel: "Completo",
        backgroundColor: theme?.palette?.primary?.dark,
        color: theme?.palette?.primary?.light,
      };
    } else if (formStatus === "INCIDENCIA") {
      btnParams = {
        disabled: false,
        buttonLabel: "Editar",
        backgroundColor: theme?.palette?.primary?.accent,
        color: "#FFFFFF",
      };
    }

    setBtnParams(btnParams);
  };

  useEffect(() => {
    generateButtonParams();
  }, [formStatus]);

  return (
    <Button
      variant="expediente"
      size={isMobileOrTablet ? "small" : "medium"}
      onClick={onClick}
      disabled={btnParams.disabled}
      sx={{
        backgroundColor: btnParams.backgroundColor,
        color: btnParams.color,
        opacity: fakeDisabled ? 0.5 : 1,
        ...(isMobileOrTablet
          ? {
              width: "auto",
              maxWidth: "100%",
              height: "auto",
              minHeight: "23px",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              textAlign: "center",
              lineHeight: 1.15,
              paddingTop: "6px",
              paddingBottom: "6px",
            }
          : null),
        "&:hover": {
          backgroundColor: btnParams.backgroundColor,
        },
        "&.Mui-disabled": {
          backgroundColor: btnParams.backgroundColor,
          color: btnParams.color,
          opacity: 1,
        },
      }}
    >
      {btnParams.buttonLabel}
    </Button>
  );
};

export default ButtonFormEnum;
